import { css } from 'styled-components'

export const chatbotRevealAnimation = css`
  opacity: 0;
  animation: chatbot-fade-in 1s linear forwards;

  @keyframes chatbot-fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
